import { FullState } from '../../store';
import { createSelector } from 'reselect';
import { PoiModalState } from '../../types/poiModal';

export const getPoiModal = (state: FullState): PoiModalState => state.poiModal;

export const getSelectedFlightlogEvent = createSelector(
  [getPoiModal],
  (poiModal: PoiModalState) => poiModal.selectedFlightlogEvent
);

export const getNearbyPois = createSelector(
  [getPoiModal],
  (poiModal: PoiModalState) => poiModal.nearbyPois
);

export const getLoadingNearbyPois = createSelector(
  [getPoiModal],
  (poiModal: PoiModalState) => poiModal.loadingNearbyPois
);

export const getAllLocationTypes = createSelector(
  [getPoiModal],
  (poiModal: PoiModalState) => poiModal.allLocationTypes
);

export const getDraftForm = createSelector(
  [getPoiModal],
  (poiModal: PoiModalState) => poiModal.draftForm
);
